import gql from 'graphql-tag';

import searchResultFragment from './searchResultFragment';

export const searchResultsPageFragment = gql`
  fragment searchResultsPageFragment on SearchResultsPage {
    dokkioClass
    total
    idsHash
    searchResults {
      ...searchResultFragment
    }
  }
  ${searchResultFragment}
`;
export default searchResultsPageFragment;
